// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Loader } from './bus/loader.js';
import VueResource from 'vue-resource'
import VeeValidate, { Validator } from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import VueMuuri from 'vue-muuri';
import 'vue-muuri/dist/vue-muuri.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import messagesGerman from 'vee-validate/dist/locale/de';
import ListWizard from '@/components/99_wizards/ListWizard'
import ProvidersForm from '@/components/03_provider/ProvidersForm'
import ProvidersView from '@/components/03_provider/ProvidersView'
import CouponsForm from '@/components/04_coupon/CouponsForm'
import CouponsView from '@/components/04_coupon/CouponsView'
import UsersForm from '@/components/07_user/UsersForm'
import UsersView from '@/components/07_user/UsersView'
import TextsForm from '@/components/11_text/TextsForm'
import TextsView from '@/components/11_text/TextsView'
import CustomersForm from '@/components/05_customer/CustomersForm'
import TextBox from '@/components/98_ui/TextBox'

// Set config options
Vue.config.productionTip = false;
Vue.router = router;

// Include components
Vue.component('vrnu-providers-form', ProvidersForm);
Vue.component('vrnu-providers-view', ProvidersView);
Vue.component('vrnu-coupons-form', CouponsForm);
Vue.component('vrnu-coupons-view', CouponsView);
Vue.component('vrnu-customers-form', CustomersForm);
Vue.component('vrnu-users-form', UsersForm);
Vue.component('vrnu-users-view', UsersView);
Vue.component('vrnu-texts-form', TextsForm);
Vue.component('vrnu-texts-view', TextsView);
Vue.component('vrnu-text-box', TextBox);

// Install packages
Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(VueMuuri);
Vue.use(require('@websanova/vue-auth'), {
	auth: require('@websanova/vue-auth/drivers/auth/body.js'),
    http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar: 'role',
    tokenStore: ['cookie', 'localStorage'],
    authRedirect: { path: '/login' },
    forbiddenRedirect: { path: '/403' },
    // notFoundRedirect: { path: '/404' },
});

// VeeValidate settings
Validator.localize('de', messagesGerman);
Vue.use(VeeValidate, {
	classNames: {
		invalid: 'form-field-invalid',
	},
	classes: true,
	fieldsBagName: 'fieldsBag',
	locale: 'de',
});

// DatePicker settings
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
      time: 'icon-clock',
      date: 'icon-calendar',
      up: 'icon-up-open',
      down: 'icon-down-open',
      previous: 'icon-left-open',
      next: 'icon-right-open',
      today: 'icon-home',
      clear: 'icon-cancel-circled',
      close: 'icon-cancel'
    }
});

// VueResource settings
// Vue.http.options.root = 'http://localhost:3000';
Vue.http.options.root = 'https://vrnu02.vs.sicor-kdl.net/';

// Configure loading animations in an interceptor
Vue.http.interceptors.push(function(request, next) {
	// Start loading animation before sending request
	Loader.$emit("startLoadingAnimation");
	
	// Finish loading animation after receiving response
	next(function(response) {
		Loader.$emit("stopLoadingAnimation");
	});
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js